// extracted by mini-css-extract-plugin
export default {"root":"style_root__5Npk1","title":"style_title__ViR8G","count":"style_count__o73GG","link":"style_link__GrwHX"};